import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import LogoHyundai from "../../images/assets/hyundai-logo.png";
import "./css/menu.css";
import { useHistory } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ShowroomDropdown from "./ShowroomDropdown";

function Menu() {
    const history = useHistory();
    const location = useLocation();
    const [showMantenimiento, setShowMantenimiento] = useState(false);
    const handleMouseEnter = () => setShowMantenimiento(true);
    const handleMouseLeave = () => setShowMantenimiento(false);
    const controlSubmenu = (opcion) => {
        const mantenimiento = document.getElementById("mantenimiento");
        const seguro = document.getElementById("seguro");
        const garantia = document.getElementById("garantia");
        if (mantenimiento) mantenimiento.className = "";
        if (seguro) seguro.className = "";
        if (garantia) garantia.className = "";
        switch (opcion) {
            case "garantia":
                history.push('/condiciones')
                break;
            case "seguro":
                history.push('/seguro-hyundai')
                break;
            case "repuestos":
                history.push('/repuestos')
                break;
            case "campañas":
                history.push('/campanas')
                break;
            case "hojas-rescate":
                history.push('postventa/rescue-sheets')
                break;
            case "ventas":
                history.push('/ventas');
                break;
            case "citas-taller":
                history.push('/citas-taller');
                break;
            case "configura":
                history.push('/configura-tu-hyundai')
                break;
            case "vehiculos":
                history.push('/vehiculos')
                break;

            default:
                break;
        }
    };

    return (
        <Fragment >
            <div className="fondo"></div>
            {/* Header solo en desktop */}
            <header className="d-none d-sm-block">
                <Container className="container-custom" >
                    <Row className="justify-content-between ">
                        <div className="barra-menu ">
                            <ul className="flex-wrap">
                                {/*<li >
                                    <Link to="/terminos-y-condiciones" className="text-reset">
                                        Términos y condiciones
                                    </Link>
                                </li>
                                <li>|</li>*/}
                                <li >
                                    <Link to="/politica-privacidad" className="text-reset">
                                        Políticas de privacidad y Protección de datos
                                    </Link>
                                </li>
                                <li>|</li>
                                <li>
                                    <Link to="/mercado-valores" className="text-reset">
                                        Mercado de valores
                                    </Link>
                                </li>
                                <li>|</li>
                                <li >
                                    <Nav.Link
                                        href="politica-calidad-antisoborno.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-reset "
                                        style={{ marginLeft: -15 }}
                                    >
                                        Política de calidad
                                    </Nav.Link>
                                </li>
                                <li>|</li>
                                <li >
                                    <Link to="/mision-vision" className="text-reset">
                                        Misión y Visión
                                    </Link>
                                </li>
                                <li>|</li>
                                <li>
                                    <Nav.Link
                                        href="https://hyundai.hiringroom.com/jobs"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="nav-link-barra text-reset"
                                    >
                                        Trabaja con nosotros
                                    </Nav.Link>
                                </li>
                            </ul>
                        </div>
                    </Row>
                </Container>
            </header>
            {/* Menú principal */}
            <div>
                {/* Menú móvil: solo visible en pantallas pequeñas */}
                <Navbar expand={false} className="menu-navbar p-0 signage-navbar">
                    <Container fluid className="p-0">
                        <div className="w-100 d-flex align-items-center justify-content-between" style={{ padding: '0.5rem 1rem' }}>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Brand as={Link} to="/" className="menu-logo-start m-0">
                                <LazyLoadImage src={LogoHyundai} alt="Logo Hyundai" width={120} height={20} />
                            </Navbar.Brand>
                        </div>
                        <Navbar.Collapse id="basic-navbar-nav" className="w-100" style={{ background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                            <Nav className="flex-column align-items-start w-100 px-3">
                                <Nav.Link id="vehiculos" className={location.pathname === '/vehiculos' ? 'nav-link active' : 'nav-link '} onClick={() => controlSubmenu("vehiculos")}>Vehiculos</Nav.Link>
                                <Nav.Link id="comerciales" className="nav-link" href="https://camiones.hyundai.com.ec" target="_blank" rel="noopener noreferrer">Camiones & Buses</Nav.Link>
                                <NavDropdown title="Showroom virtual" id="showroom-dropdown" style={{ fontSize: '14px', width: '100%' }}>
                                    <div style={{ padding: 0 }}>
                                        <ShowroomDropdown />
                                    </div>
                                </NavDropdown>
                                <NavDropdown title="Posventa" id="postventa-dropdown" style={{ fontSize: '14px', width: '100%' }}>
                                    <NavDropdown title="Mantenimiento" id="mantenimiento-submenu" className="mantenimiento-dropdown" show={showMantenimiento} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ width: '100%' }}>
                                        <NavDropdown.Item id="citas-taller" onClick={() => history.push('/citas-taller')} style={{ fontSize: '14px' }}>Agenda tu cita</NavDropdown.Item>
                                        <NavDropdown.Item id="plan-manteniminto" onClick={() => history.push('/mantenimiento')} style={{ fontSize: '14px' }}>Planes de Mantenimiento</NavDropdown.Item>
                                        <NavDropdown.Item id="prepagado" onClick={() => history.push('/prepagados')} style={{ fontSize: '14px' }}>Mantenimiento Prepagado</NavDropdown.Item>
                                        <NavDropdown.Item id="manual-propietario" onClick={() => history.push('/manual-del-propietario')} style={{ fontSize: '14px' }}>Manual de propietario</NavDropdown.Item>
                                    </NavDropdown>
                                    <NavDropdown.Item id="garantia" onClick={() => controlSubmenu("garantia")} style={{ fontSize: '14px' }} className="menu-item-spacing">Garantía</NavDropdown.Item>
                                    <NavDropdown.Item id="seguro" onClick={() => controlSubmenu("seguro")} style={{ fontSize: '14px' }}>Hyundai Seguro</NavDropdown.Item>
                                    <NavDropdown.Item id="campañas" onClick={() => controlSubmenu("campañas")} style={{ fontSize: '14px' }}>Campañas Hyundai</NavDropdown.Item>
                                    <NavDropdown.Item id="repuestos" onClick={() => controlSubmenu("repuestos")} style={{ fontSize: '14px' }}>Cotiza tu repuesto</NavDropdown.Item>
                                    <NavDropdown.Item id="hojas-rescate" onClick={() => controlSubmenu("hojas-rescate")} style={{ fontSize: '14px' }}>Hojas de rescate</NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link id="repuestos" className={location.pathname === '/repuestos' ? 'nav-link active' : 'nav-link '} onClick={() => controlSubmenu("repuestos")}>Repuestos</Nav.Link>
                                <NavDropdown title="Red de concesionarios" id="concesionarios-dropdown" style={{ fontSize: '14px', width: '100%' }}>
                                    <NavDropdown.Item id="ventas" onClick={() => controlSubmenu("ventas")} style={{ fontSize: '14px' }}>Ventas</NavDropdown.Item>
                                    <NavDropdown.Item id="citas-taller" onClick={() => controlSubmenu("citas-taller")} style={{ fontSize: '14px' }}>Talleres</NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link id="configura" className={location.pathname === '/configura-tu-hyundai' ? 'nav-link active' : 'nav-link '} onClick={() => controlSubmenu("configura")}>Configura tu Hyundai</Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                {/* Menú desktop: estructura original previa a los cambios de separación y alineación */}
                {/* Menú desktop: solo visible en pantallas grandes */}
                <Navbar expand="lg" className="menu-navbar desktop-navbar align-items-center">
                    <Navbar.Brand as={Link} to="/" className="menu-logo-start mr-4">
                        <LazyLoadImage src={LogoHyundai} alt="Logo Hyundai" width={235} height={25} />
                    </Navbar.Brand>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="menu-content ml-auto align-items-center" style={{ width: '100%' }}>
                            <Nav.Link id="vehiculos" className={`nav-link${location.pathname === '/vehiculos' ? ' active' : ''}`} onClick={() => controlSubmenu("vehiculos")}> <span>Vehiculos</span></Nav.Link>
                            <Nav.Link id="comerciales" className="nav-link" href="https://camiones.hyundai.com.ec" target="_blank" rel="noopener noreferrer">Camiones & Buses</Nav.Link>
                            <NavDropdown title="Showroom virtual" id="showroom-dropdown" style={{ fontSize: '5px', minWidth: '40px' }}>
                                <ShowroomDropdown />
                            </NavDropdown>
                            <NavDropdown title="Posventa" id="postventa-dropdown" style={{ fontSize: '14px' }}>
                                <NavDropdown title="Mantenimiento" id="mantenimiento-submenu" className={`mantenimiento-dropdown ${window.innerWidth >= 900 ? "btn-group dropright " : ""}mantenimiento-dropdown `} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} show={showMantenimiento}>
                                    <NavDropdown.Item id="citas-taller" onClick={() => history.push('/citas-taller')} style={{ fontSize: '14px' }}>Agenda tu cita</NavDropdown.Item>
                                    <NavDropdown.Item id="plan-manteniminto" onClick={() => history.push('/mantenimiento')} style={{ fontSize: '14px' }}>Planes de Mantenimiento</NavDropdown.Item>
                                    <NavDropdown.Item id="prepagado" onClick={() => history.push('/prepagados')} style={{ fontSize: '14px' }}>Mantenimiento Prepagado</NavDropdown.Item>
                                    <NavDropdown.Item id="manual-propietario" onClick={() => history.push('/manual-del-propietario')} style={{ fontSize: '14px' }}>Manual de propietario</NavDropdown.Item>
                                </NavDropdown>
                                <NavDropdown.Item id="garantia" onClick={() => controlSubmenu("garantia")} style={{ fontSize: '14px' }} className="menu-item-spacing">Garantía</NavDropdown.Item>
                                <NavDropdown.Item id="seguro" onClick={() => controlSubmenu("seguro")} style={{ fontSize: '14px' }}>Hyundai Seguro</NavDropdown.Item>
                                <NavDropdown.Item id="campañas" onClick={() => controlSubmenu("campañas")} style={{ fontSize: '14px' }}>Campañas Hyundai</NavDropdown.Item>
                                <NavDropdown.Item id="repuestos" onClick={() => controlSubmenu("repuestos")} style={{ fontSize: '14px' }}>Cotiza tu repuesto</NavDropdown.Item>
                                <NavDropdown.Item id="hojas-rescate" onClick={() => controlSubmenu("hojas-rescate")} style={{ fontSize: '14px' }}>Hojas de rescate</NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link id="repuestos" className={location.pathname === '/repuestos' ? 'nav-link active' : 'nav-link '} onClick={() => controlSubmenu("repuestos")}>  <span>Repuestos</span></Nav.Link>
                            <NavDropdown title="Red de concesionarios" id="concesionarios-dropdown" style={{ fontSize: '14px' }}>
                                <NavDropdown.Item id="ventas" onClick={() => controlSubmenu("ventas")} style={{ fontSize: '14px' }}>Ventas</NavDropdown.Item>
                                <NavDropdown.Item id="citas-taller" onClick={() => controlSubmenu("citas-taller")} style={{ fontSize: '14px' }}>Talleres</NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link id="configura" className={location.pathname === '/configura-tu-hyundai' ? 'nav-link active' : 'nav-link '} onClick={() => controlSubmenu("configura")}> <span>Configura tu Hyundai</span></Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        </Fragment>
    );
}
export default Menu;